import { render, staticRenderFns } from "./LookupComponentSubCollection.vue?vue&type=template&id=2122f44a&"
import script from "./LookupComponentSubCollection.vue?vue&type=script&lang=js&"
export * from "./LookupComponentSubCollection.vue?vue&type=script&lang=js&"
import style0 from "./LookupComponentSubCollection.vue?vue&type=style&index=0&id=2122f44a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports